<template>
  <split-screen>
    <template v-slot:left>
      <div v-if="content" class="content pb-6">
        <span class="block mb-24" v-html="content[`about_${lang}`]" />
      </div>
    </template>
    <template v-slot:right>
      <div class="cosmo-gif relative flex flex-col items-center justify-center h-full text-white">
        <span class="absolute top-0 left-0 text-center mt-24 w-full tracking-wide">23 October – 23 December 2019</span>
        <span class="blur" style="font-size: 5.5vw">About</span>
        <span class="absolute bottom-0 left-0 text-center mb-24 w-full tracking-wide">Centre Georges Pompidou</span>
      </div>
    </template>
  </split-screen>
</template>

<script>
import { mapState } from 'vuex'
import SplitScreen from '@/views/SplitScreen'

export default {
  name: 'About',
  data () {
    return {
    }
  },
  components: {
    SplitScreen
  },
  computed: {
    ...mapState([
      'content',
      'lang'
    ])
  }
}
</script>

<style lang="stylus" scoped>
>>> p
  @apply mb-6

>>> hr
  border: none
  margin: 3em 0

>>> img
  margin: 3em 0
</style>
